import { TimelineMax, Expo } from 'gsap/TweenMax';

const link = (el) => {
  const tl = new TimelineMax({
    paused: true,
    smoothChildTiming: true,
  });

  const item = Array.from(el.querySelectorAll('.link > span', el));
  const hover = Array.from(el.querySelectorAll('.hover > span', el));

  tl
    .add('start')
    .set(hover, {
      yPercent: 10,
      autoAlpha: 0,
    }, 'start')
    .staggerTo(item, 0.3, {
      yPercent: -10,
      autoAlpha: 0,
      ease: Expo.easeOut,
    }, 0.05, 'start')
    .staggerTo(hover, 0.3, {
      yPercent: 0,
      autoAlpha: 1,
      ease: Expo.easeOut,
    }, 0.05, 'start+=0.3');

  return tl;
};

export default link;
